export enum AuthStep {
  LOGIN = "/login",
  REGISTRATION = "/registration",
  FORGOT_PASSWORD = "/forgot-password",
  VALIDATION = "/validation",
  RESET_PASSWORD = "/reset-password",
}
